import aufb from "../../../assets/images/Customer/aufb.svg";
import auin from "../../../assets/images/Customer/auin.svg";
import auzl from "../../../assets/images/Customer/auzl.svg";

function getCategoryName(categories, ids) {
  const arrIds = ids
    ? ids
        .split(",")
        .map((num) => Number(num))
        .filter((n) => n > 0)
    : [];
  const cat = categories.find(
    (item) => item.id == (arrIds.length > 0 ? arrIds[0] : 0)
  );
  return cat?.name ?? "";
}

export default function EventDetailHead({ article, imgBanner, categories }) {
  return (
    <div className="w-full">
      {article && (
        <div className="w-full container mx-auto px-[20px] py-[20px] flex flex-col gap-3">
          <div>
            <p className="text-[16px] text-[#919191] font-normal">
              Tin tức - Công nghệ giáo dục
            </p>
          </div>
          <div>
            <p className="text-[28px] text-[#1F1F1F] font-semibold">
              {article.title}
            </p>
          </div>
          <div>
            <img
              src={imgBanner}
              alt="im"
              className="block w-full h-auto object-fill"
            />
          </div>
          <div>
            <div className="w-full flex flex-col gap-3 md:flex-row items-center">
              <div className="w-full flex justify-between items-center">
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[16px] text-[#606060] font-medium">
                    Tác giả
                  </p>
                  <p className="text-[16px] text-[#053CC8] font-medium">
                    {article.author}
                  </p>
                </div>
                <div class="w-px h-16 bg-gray-300"></div>

                <div className="w-full flex flex-col gap-1 pl-10">
                  <p className="text-[16px] text-[#606060] font-medium">
                    Đăng ngày
                  </p>
                  <p className="text-[16px] text-[#053CC8] font-medium">
                    {new Date(article.publishDate).toLocaleDateString()}
                  </p>
                </div>
              </div>
              <div class="w-px h-16 bg-gray-300 hidden md:block"></div>
              <div className="w-full flex justify-between items-center">
                <div className="w-full flex flex-col gap-1">
                  <p className="text-[16px] text-[#606060] font-medium">
                    Chủ đề
                  </p>
                  <p className=" text-[16px] text-[#053CC8] font-medium">
                    {getCategoryName(categories, article.categories)}
                  </p>
                </div>
                <div class="w-px h-16 bg-gray-300"></div>

                <div className="w-full flex flex-col gap-1 pl-10">
                  <div>
                    <p className="text-[16px] text-[#606060] font-medium">
                      Chia sẻ
                    </p>
                  </div>
                  <div className="w-full flex items-center gap-2">
                    <img src={aufb} alt="au" />
                    <img src={auin} alt="aum" />
                    <img src={auzl} alt="ni" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="leading-10"
            dangerouslySetInnerHTML={{ __html: article.mainContent }}
          />
        </div>
      )}
    </div>
  );
}
